<template>

  <dmb-asset class="element-background" :style="{ 'z-index': zIndex }" :color="color" :repeat="false" :content-mode="contentMode" :asset-id="assetId" />

</template>

<script>

import {Vue, Options} from "vue-class-component";

import Asset from "./Asset.vue";
import AssetContentMode from "../../enum/AssetContentMode";

export default Options({
  name: "dmb-element-background",
  components: {
    [Asset.name]: Asset
  },
  props: {
    assetId: String,
    contentMode: {
      type: String,
      default: AssetContentMode.COVER
    },
    repeat: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: String,
      default: "-100"
    },
    color: {
      type: String
    }
  }
})(
    class ElementBackground extends Vue {

    }
);

</script>

<style lang="scss" src="../../../scss/component/ui/ElementBackground.scss"></style>